module.exports = __webpack_public_path__ + "img/4@2x.018d70e0.png";